// FORMAT NUMBER
function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

function updateFullPrice() {
    var sum = 0;
    $('.cart').each(function(){
        if($('input',this).val() !==undefined)
            sum += $('input',this).val() * $('.js-price',this).data('default-price');
    });
    if ($('#js-discount').length > 0) {
        sum -= parseInt($('#js-discount').val());
    }
    var sumWithCourier = sum;
    if ($('input:radio[name=shipping_method]:checked').data('shipping_method') === "courier" || $('input:radio[name=shipping_method]:checked').data('shipping_method') === "courier_eu") {
        sumWithCourier += parseInt($('input:radio[name=shipping_method]:checked').data('method-price'));
    }
    $('.js-full-price').html(formatNumber(sumWithCourier) + ' Ft');
    $('.js-full-no-vat-price').html(formatNumber(Math.round(sum/127*100)) + ' Ft');
}

function updatePrice(cart,val) {
    var price = cart.parents('.cart').find('.js-price');
    var defaultPrice = price.data('default-price');
    price.attr('data-current-price',val*defaultPrice);
    price.html(formatNumber(val*defaultPrice) + ' Ft');

    updateFullPrice();
}

(function($) {
    $(function() {

        if ($('.js-full-price').length > 0) {
            updateFullPrice();
        }

        // CUSTOM NUMBER INPUT CHANGES
        $('.own-number .change').click(function (e) {
            var toDo = $(this).data('to-do');
            var input = $(this).parents('.own-number').find('input[name="qty2"]');
            var form = $(this).parents(".form-group").find('.js-submit-cart-item');
            var formInputQty = form.find('input[name="qty"]');

            if ($(this).hasClass('plus') && (input.attr('max') > parseInt(input.val()))) {
                input.val(parseInt(input.val()) + 1);
                formInputQty.val(parseInt(formInputQty.val()) + 1);
                form.trigger('submit');

                if(parseInt(input.val()) != 0) {
                    $(this).parents('.own-number').find('.change.minus').removeClass('is-hidden');
                }
                updatePrice($(this),parseInt(input.val()));
            }
            if ($(this).hasClass('minus') && (input.attr('min') < parseInt(input.val()))) {
                if (parseInt(input.val()) > 1) {
                    input.val(parseInt(input.val()) - 1);
                    formInputQty.val(parseInt(formInputQty.val()) - 1);
                    form.trigger('submit');
                }

                if(parseInt(input.val()) == 1) {
                    $(this).addClass('is-hidden');
                }
                updatePrice($(this),parseInt(input.val()));
            }

            $(this).parents('.own-number').find('.number span').html(input.val());
        });

        $(".header-cart img").click(function() {
            $(".header-cart__content").toggleClass("is-showed");

            if ($(".header-cart__content").hasClass("is-showed")) {
                $("body").addClass("fixed");
            } else {
                $("body").removeClass("fixed");
            }

            $(".navbar-collapse").removeClass("is-opened");
            $(".navbar-toggler").removeClass("is-active");
            $(".search-bar").removeClass("is-opened");
            closeMenu();
        });

        $(document).mouseup(function(e) {
            var container = $(".header-cart img, .header-cart__content");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $(".header-cart__content").removeClass("is-showed");
            }
        });

        // delete product from cart
        $('.js-submit-cart-remove').submit(function (e, data) {
            e.preventDefault();
            var action = $(this).attr('action');
            var form_data = {};
            $.map($(this).serializeArray(), function (value) {
                form_data[value.name] = value.value;
            });
            var product = $(this).parents(".cart");

            $.ajax({
                url: action,
                method: "POST",
                dataType: 'json',
                data: form_data,
            }).done(function (data) {
                $('#js-discount').val(data.total_without_coupon - data.total)
                $('#js-discount-html span').html(formatNumber(data.total_without_coupon - data.total))
                product.slideUp(200, function() {
                    product.remove()
                    // updateCart(data.items)
                    updateFullPrice();
                    //TODO coupon price
                });
                if (data.items.length === 0) {
                    $('.js-checkout-btn').remove();
                }
            })
        });

        $('.js-submit-cart-item').submit(function (e, data) {
            e.preventDefault();
            var action = $(this).attr('action');
            var form_data = {};
            $.map($(this).serializeArray(), function (value) {
                form_data[value.name] = value.value;
            });

            $.ajax({
                url: action,
                method: "POST",
                dataType: 'json',
                data: form_data,
            }).done(function (data) {
                $('#js-discount').val(data.total_without_coupon - data.total)
                $('#js-discount-html span').html(formatNumber(data.total_without_coupon - data.total))
                // updateCart(data.items);
                // updateTotal();
            })

        });
    });
})(jQuery);
